import { memo } from 'react';

import { JoyajoyImage } from '../JoyajoyImage';
import './IconInfoCell.css';

type IconInfoCellProps = {
  icon: string;
  title: string;
  description: string;
};

export const IconInfoCell = memo(
  ({ icon, title, description }: IconInfoCellProps) => {
    return (
      <div className="icon-info-cell">
        <JoyajoyImage resource={{ uri: icon }} className="icon" />
        <div className="content">
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
      </div>
    );
  },
);
